export const InvestmentValuationUploadConfig = {
	list: 'InvestmentValuation',
	grid: {
		gridId: 'InvestmentValuationUploadGrid',
		checkbox: false,
		edit: false,
		delete: true,
		height: 500,
		pageSize: 10,
		groupable: false
	},
	columns: {
		InvestmentValuationKey: {
			dataName: 'InvestmentValuationKey',
			type: 'string',
			title: 'InvestmentValuationKey',
			width: 220,
			hidden: true
		},
		Validation: {
			dataName: 'Validation',
			type: 'string',
			title: 'Validation',
			width: 130,
			hidden: false
		},
		InvestmentInvestmentID: {
			dataName: 'InvestmentInvestmentID',
			type: 'string',
			title: 'Investment ID',
			width: 200,
			hidden: false
		},
		InvestmentTitle: {
			dataName: 'InvestmentTitle',
			type: 'string',
			title: 'Investment',
			width: 130,
			hidden: false
		},
		TaxYear: {
			dataName: 'TaxYear',
			type: 'string',
			title: 'Tax Year',
			width: 170,
			hidden: false
		},
		TaxQuarter: {
			dataName: 'TaxQuarter',
			type: 'string',
			title: 'Tax Quater',
			width: 200,
			hidden: false
		},
		ProjectedValue: {
			dataName: 'ProjectedValue',
			type: 'number',
			title: 'Projected Value',
			template: '#=kendo.toString(ProjectedValue, "c")#',
			width: 250,
			hidden: false
		},
		CurrentValue: {
			dataName: 'CurrentValue',
			type: 'number',
			title: 'Current Value',
			template: '#=kendo.toString(CurrentValue, "c")#',
			width: 200,
			hidden: false
		},

	}
}